/*
 * ProfilePage
 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import MediaQuery from 'react-responsive';
import get from 'lodash/get';

import {
    changeSearchStatus,
    addToWatchList,
    removeFromWatchList,
    addToReadList,
    removeFromReadList,
    addPersonalBook,
} from '../../modules/user';
import {
    currentLevelName,
    currentLevelImage,
    accessibleLevelName,
} from '../../helper/Helper'
import { isMobile } from '../../helper/mediaQueries';
import Profile from './Profile/Profile';
import Readings from './Readings/Readings';
import ErrorBoundary from '../../components/ErrorBoundary';
import Logout from '../../components/Logout';

import './ProfilePage.css'

class ProfilePage extends Component {
    componentWillMount() {
        if(!this.props.isLoggedIn){
            window.location.href = '/prc/logon.html';
        }
    }
    componentDidMount(){
        this.props.changeSearchStatus('reset')
    }

    render () {
        const {
            firstName,
            lastName,
            gradeName,
            schoolName,
        } = this.props.studentDetails;
        const booksRead = this.props.readList.length;
        const grade = parseInt(gradeName , 10);
        const currentLevel = currentLevelName(booksRead, grade)
        const accessibilityName = accessibleLevelName(currentLevel)
        return (
            <div className="profile-container">
                <Helmet>
                    <title>Student Profile: NSW Premier's Reading Challenge</title>
                    <meta name="description" content="Profile page"/>
                </Helmet>
                <MediaQuery query={isMobile}>
                    <div className="profile__mobile__logout">
                        <Logout />
                    </div>
                </MediaQuery>
                <ErrorBoundary>
                    <Profile
                        name={`${firstName} ${lastName}`}
                        school={schoolName}
                        grade={grade}
                        booksRead={booksRead}
                        levelName={currentLevel}
                        accessibilityName={accessibilityName}
                        levelImage={currentLevelImage(currentLevel, false)}
                    />
                </ErrorBoundary>
                <ErrorBoundary>
                    <Readings
                        booklist={this.props.booklist}
                        watchList={this.props.watchList}
                        readList={this.props.readList}
                        personalBookList={this.props.personalBookList}
                        addToWatchList={this.props.addToWatchList}
                        removeFromWatchList={this.props.removeFromWatchList}
                        addToReadList={this.props.addToReadList}
                        removeFromReadList={this.props.removeFromReadList}
                        addPersonalBook={this.props.addPersonalBook}
                        levelName={currentLevel}
                        levelImage={currentLevelImage(currentLevel, true)}
                        isHighGrade={grade > 2}
                        tabValue={this.props.tabValue}
                        studentName={this.props.studentName}
                    />
                </ErrorBoundary>
            </div>
        );
    }
}


const mapStateToProps = state => {
    const firstName = get(state, 'student.studentDetails.firstName');
    const lastName = get(state, 'student.studentDetails.lastName');
    return ({
        studentDetails: state.student.studentDetails,
        booklist: state.user.bookList,
        watchList: state.user.watchList,
        readList: state.user.readList,
        personalBookList: state.user.personalBookList,
        isLoggedIn: !!get(state, 'student.studentDetails.studentId'),
        tabValue: state.user.tabValue,
        studentName: [firstName, lastName].filter(n => !!n).join(' ')
    });
}

const mapDispatchToProps = dispatch => bindActionCreators({
    changeSearchStatus,
    addToWatchList,
    removeFromWatchList,
    addToReadList,
    removeFromReadList,
    addPersonalBook,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProfilePage);

